import { put, all, select } from "redux-saga/effects";
import _ from "lodash";

import { selectors, actions } from "rdx";
import makeRequest from "rdx/utils/makeRequest";
import { camelizeKeys, formatPreSalesProject } from "lib/helpers";
import messages from "../messages";

function* updatePreSalesMilestones(action) {
  const { id } = action.payload;
  const { providerLead } = yield select(selectors.getProjectDetails);
  const adminProjectDetails = yield select(selectors.getAdminProjectDetails);

  const params = _.omitBy(
    {
      contract_out: action.payload.data.contractOut,
      proposal_presented: action.payload.data.proposalPresented,
      product: action.payload.data.product,
      id,
    },
    _.isNil,
  );

  const { success, data, error } = yield* makeRequest.patch(`/provider_leads/${id}/pre_sales_milestones`, params);
  if (success && data) {
    const projectDetails = camelizeKeys(data.body);
    yield all([
      ...(providerLead?.id === id ? [put(actions.setProjectDetails({ providerLead: projectDetails }))] : []),
      ...(adminProjectDetails?.id === id ? [put(actions.getAdminProjectDetails({ projectId: id }))] : []),
      put(actions.updatePreSalesProject(formatPreSalesProject(projectDetails))),
      put(
        actions.newSuccessEvent({
          message: messages.UPDATE_PRE_SALES_MILESTONES_SUCCESS,
        }),
      ),
      put(
        actions.setAlertMessageVisible({
          message: messages.UPDATE_PRE_SALES_MILESTONES_SUCCESS,
          severity: "success",
        }),
      ),
    ]);
  } else {
    return yield put(actions.setFormErrors({ error }));
  }
  return null;
}

export default updatePreSalesMilestones;
